import { Link } from "react-router-dom";
import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function GeschenkOpa() {
  return (
    <MarketingPage
      eyebrow="Geschenk · für Opa"
      h1={
        <>
          Das Geschenk für Opa, das mehr ist als ein weiterer{" "}
          <Swoosh>Schlips</Swoosh>
        </>
      }
      lead={
        <>
          Großväter sind oft die schwierigste Geschenkgruppe der Familie. Sie
          wollen nichts, sie brauchen nichts, sie sammeln nichts. Was sie
          meistens haben, sind Geschichten — über Werkstätten, Kollegen,
          Ehefrauen, Reisen, schwere Jahre und gute Jahre. Vitanara gibt
          diesen Geschichten ein Buch.
          <br />
          <br />
          Opa ruft Konrad oder Ida an, wann er mag. Erzählt, fragt sich
          selbst etwas, schweigt zwischendurch, fängt neu an. Nach rund
          zwölf Wochen halten Sie ein in Leinen gebundenes Buch in der
          Hand — seines.
        </>
      }
      sections={[
        {
          h2: "Warum Großväter mit Vitanara oft besser klarkommen als gedacht",
          body: (
            <p style={{ margin: 0 }}>
              Viele ältere Männer wirken zunächst zurückhaltend, wenn es ums
              Erzählen geht. Erfahrungsgemäß ändert sich das nach dem zweiten
              oder dritten Anruf — gerade weil am anderen Ende der Leitung
              kein Familienmitglied sitzt, vor dem man eine Rolle einnehmen
              müsste, sondern jemand, der nur zuhört. Was am Frühstückstisch
              nie erzählt wurde, kommt am Hörer manchmal überraschend.
            </p>
          ),
        },
        {
          h2: "Anlässe für Opa",
          body: (
            <>
              <p style={{ margin: "0 0 10px" }}>
                <strong>
                  Achtzigster, fünfundachtzigster, neunzigster Geburtstag.
                </strong>{" "}
                Ein Buch statt einer weiteren Krawatte.
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Goldene Hochzeit.</strong> Wenn Opa und Oma gemeinsam
                erzählen, entsteht ein besonderes Doppelbuch. Mehr dazu auf{" "}
                <Link
                  to="/goldene-hochzeit-geschenk"
                  style={{ color: "var(--oxblood)", textDecoration: "none" }}
                >
                  Goldene Hochzeit Geschenk
                </Link>
                .
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Vatertag.</strong> Der wahrscheinlich
                unterschätzteste Anlass für Vitanara — weil Väter selten
                zugeben, dass sie ein solches Geschenk eigentlich wollen.
              </p>
              <p style={{ margin: 0 }}>
                <strong>Ruhestand.</strong> Ein Kapitel endet, ein anderes
                wird geschrieben.
              </p>
            </>
          ),
        },
        {
          h2: "Was, wenn Opa nicht über alles reden will?",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Viele Großväter haben Erfahrungen, über die in der Familie
                nie gesprochen wurde — Kriegskindheit, Flucht, Vertreibung,
                schwere berufliche Jahre, Verluste. Konrad und Ida fragen nie
                nach, was offensichtlich nicht erzählt werden soll. Themen,
                die Opa selbst anstößt, werden behutsam aufgenommen. Themen,
                die er auslässt, bleiben aus.
              </p>
              <p style={{ margin: 0 }}>
                Das Ergebnis ist kein Verhör, sondern ein Gespräch. Und ein
                Buch, in dem Lücken sein dürfen.
              </p>
            </>
          ),
        },
        {
          h2: "Stimmen aus der Familie",
          body: (
            <p style={{ margin: 0 }}>
              Manche Geschichten kommen erst, wenn die Familie sie nicht
              mehr direkt hört:
            </p>
          ),
          quote: {
            text: "Mein Opa hat fünfzig Jahre kein Wort über die Werft gesagt, in der er gearbeitet hat. Im Buch sind jetzt achtzehn Seiten darüber.",
            who: "Niklas, 34",
          },
        },
      ]}
      faqs={[
        {
          q: "Opa hört schlecht – geht das?",
          a: "Ja, solange er ein normales Telefongespräch führen kann. Konrad und Ida sprechen ruhig und deutlich.",
        },
        {
          q: "Opa lebt im Pflegeheim – geht das?",
          a: "Wenn ein Festnetz oder ein Telefon im Zimmer vorhanden ist, ja. Wir empfehlen kurze, häufigere Anrufe statt langer Sitzungen.",
        },
        {
          q: "Was, wenn Opa zwischendrin krank wird?",
          a: "Eine Pause ist jederzeit möglich. Es gibt keine Frist.",
        },
      ]}
      crossLinks={[
        {
          to: "/geschenk-fuer-oma",
          label: "Geschenk für Oma",
          blurb:
            "Was eine Großmutter erzählt, wenn ihr jemand drei Monate zuhört.",
        },
        {
          to: "/goldene-hochzeit-geschenk",
          label: "Goldene Hochzeit Geschenk",
          blurb: "Fünfzig Jahre Ehe als gemeinsames Buch mit zwei Stimmen.",
        },
        {
          to: "/biografie-schreiben-lassen",
          label: "Biografie schreiben lassen",
          blurb:
            "Was klassische Biografen anders machen — und was bei Vitanara bleibt.",
        },
      ]}
    />
  );
}
